exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\nbody.fullframe {\n    overflow: hidden;\n}\n", "", {"version":3,"sources":["D:/a/8/s/AFBPlay/src/components/Page/UserManual.vue"],"names":[],"mappings":";AACA;IACI,iBAAiB;CACpB","file":"UserManual.vue","sourcesContent":["\nbody.fullframe {\n    overflow: hidden;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b1da3938","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Page/UserManual.vue
// module id = +ib6
// module chunks = 2